module.exports = __webpack_public_path__ + "static/media/storeCard.2bbf4558.webp";